export const VIDEO_COVER_DATA_TEST_ID = 'HOTEL_VIDEO_COVER';
export const VIDEO_COVER_IMAGE_TEST_ID = 'HOTEL_VIDEO_COVER_IMAGE';
export const VIDEO_COVER_PLAY_ICON_DATA_TEST_ID = 'HOTEL_VIDEO_COVER_PLAY_ICON';
